/* ترف theme — interactions */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function () {

    /* smooth scroll for order CTAs (works even if section is on another page) */
    function gotoOrder(e) {
      var t = document.getElementById('taraf-order');
      if (t) {
        if (e) e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 8, behavior: 'smooth' });
      } else {
        if (e) e.preventDefault();
        window.location.href = '/#taraf-order';
      }
    }
    document.querySelectorAll('a[href="#taraf-order"], .t-sticky a, .js-goto-order').forEach(function (a) {
      a.addEventListener('click', gotoOrder);
    });
    if (location.hash === '#taraf-order') { setTimeout(function () { gotoOrder(); }, 300); }

    /* bundle selection */
    var bundles = document.querySelectorAll('.t-bundle');
    var qtyInput = document.getElementById('taraf-qty');
    var sumTotal = document.getElementById('taraf-summary-total');
    var sumLabel = document.getElementById('taraf-summary-label');
    function selectBundle(el) {
      bundles.forEach(function (b) { b.classList.remove('sel'); });
      el.classList.add('sel');
      if (qtyInput) qtyInput.value = el.getAttribute('data-qty') || '1';
      if (sumTotal) sumTotal.textContent = el.getAttribute('data-total') || '';
      if (sumLabel) sumLabel.textContent = el.getAttribute('data-label') || '';
    }
    bundles.forEach(function (el) {
      el.addEventListener('click', function () { selectBundle(el); });
    });
    if (bundles.length) {
      var pre = document.querySelector('.t-bundle.sel') || bundles[0];
      selectBundle(pre);
    }

    /* FAQ accordion */
    document.querySelectorAll('.t-faq').forEach(function (f) {
      f.addEventListener('click', function () {
        var open = f.classList.contains('open');
        f.classList.toggle('open', !open);
        var i = f.querySelector('.q i');
        if (i) i.textContent = open ? '+' : '−';
      });
    });

    /* countdown timer */
    document.querySelectorAll('.taraf-timer').forEach(function (node) {
      var mins = parseInt(node.getAttribute('data-min') || '15', 10);
      var key = 'taraf_deadline';
      var dl = parseInt(sessionStorage.getItem(key) || '0', 10);
      var now = Date.now();
      if (!dl || dl < now) { dl = now + mins * 60 * 1000; sessionStorage.setItem(key, String(dl)); }
      function ar(n){ return String(n).replace(/\d/g, function(d){ return '٠١٢٣٤٥٦٧٨٩'[d]; }); }
      function pad(n){ return n < 10 ? '0' + n : '' + n; }
      function tick(){
        var left = Math.max(0, Math.floor((dl - Date.now()) / 1000));
        var m = Math.floor(left / 60), s = left % 60;
        node.textContent = ar(pad(m)) + ':' + ar(pad(s));
      }
      tick();
      setInterval(tick, 1000);
    });

  });
})();